export const LONG_CONTENT_CHARACTER_LIMIT = 1200
export const LONG_CONTENT_LINE_LIMIT = 18

export function shouldCollapseTranscriptContent(content: string) {
  return content.length > LONG_CONTENT_CHARACTER_LIMIT
    || content.split('\n').length > LONG_CONTENT_LINE_LIMIT
}

export function compactTranscriptContent(content: string) {
  if (!shouldCollapseTranscriptContent(content)) return content
  const lines = content.split('\n').slice(0, LONG_CONTENT_LINE_LIMIT)
  const byLine = lines.join('\n')
  return byLine.slice(0, LONG_CONTENT_CHARACTER_LIMIT).trimEnd()
}

export function findRetryPrompt(
  messages: Array<{ role: 'user' | 'assistant'; content: string }>,
  assistantIndex: number,
) {
  for (let index = assistantIndex - 1; index >= 0; index -= 1) {
    if (messages[index].role === 'user' && messages[index].content.trim()) {
      return messages[index].content
    }
  }
  return null
}
